import React, { useState } from 'react';
import SessionManager from '../../routes/SessionManager';
import { Table, Progress, Dropdown } from 'antd';
import moment from 'moment';
import SensorChart from './SensorChart';
import bootbox from 'bootbox';
import $ from "jquery";
import Toastr from 'toastr';
import Loading from '../Loading';
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

function SensorRecord(props) {

    let sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');
    let sensor_activity = props.sensor_activity
    const [sensors, setSensors] = useState(props.sensors)
    const [loading, setLoading] = useState(false)

    let thresholds = props.sensor_activity.group_thresh_json;

    let sensor_threshold_ranges = {};

    let sensor_table_cols = [
        {
            title: 'Sensor ID',
            dataIndex: 'sensor_serial_number',
            key: 'sensor_serial_number',
            render: (text, record) => {
                let m1 = (moment.utc().add(-20, 'minutes')).unix();
                return <div>
                    <span className={m1 <= record.sensor_dev_timestamp ? "text-success" : "text-danger"}>
                        <i className="fa fa-wifi pr-2"></i>
                    </span>{record.sensor_serial_number}
                </div>
            },
            width: '200px',
        },
        {
            title: 'Name',
            dataIndex: 'sensor_name',
            key: 'sensor_name',
            render: (text, record) => record.sensor_name && record.sensor_name.trim().length > 0 ? record.sensor_name : record.sensor_serial_number,
            width: '200px',
        },
        {
            title: 'Current',
            dataIndex: 'sensor_last_state',
            key: 'sensor_last_state',
            render: (text, record) => {
                setTimeout(() => { $('[data-toggle="tooltip"]').tooltip(); });
                return <div className="row font-size-12">
                    {

                        record.sensor_last_state && Object.keys(record.sensor_last_state).sort().map(p => {
                            let v = record.sensor_last_state[p];
                            let vRange = [];
                            let outOfRange = false;
                            let key = record.sensor_id + '_' + record.sensor_type + '_' + p;
                            switch (p) {
                                case 'hum':
                                    if (thresholds.length > 0) {
                                        vRange = sensor_threshold_ranges['humidity'];
                                        if (vRange && vRange.length === 2)
                                            outOfRange = v > vRange[1] || v < vRange[0];
                                    } else {
                                        outOfRange = false;
                                    }
                                    return <div key={key} className="col-md-2 p-2">{v === -100 ? <span>Humid: <i className="fa fa-circle text-danger" data-toggle="tooltip" title='Bad Value or Unreadable or Bad Sensor' ></i> </span> : ('Humid:' + v + "%")} <Progress percent={100} size="small" strokeColor={!outOfRange ? "#52c41a" : "red"} showInfo={false} /></div>;

                                case 'temp':
                                    if (thresholds.length > 0) {
                                        vRange = sensor_threshold_ranges['temperature'];
                                        if (vRange && vRange.length === 2)
                                            outOfRange = v > vRange[1] || v < vRange[0];
                                    } else {
                                        outOfRange = false;
                                    }
                                    return <div key={key} className="col-md-2 p-2"> {v === -100 ? <span>Temp: <i className="fa fa-circle text-danger " data-toggle="tooltip" title='Bad Value or Unreadable or Bad Sensor'></i></span> : ('Temp:' + v + "F")} <Progress percent={100} size="small" strokeColor={!outOfRange ? "#52c41a" : "red"} showInfo={false} /></div>;

                                case 'bat':
                                    return <div key={key} className="col-md-2 p-2 text-center">{'Battery: ' + v + '%'} <br /><Progress percent={v} steps={5} size="small" strokeColor={v > 50 ? "#52c41a" : v > 30 ? "orange" : "red"} trailColor="#666" showInfo={false} /></div>;

                                // case 'voc':
                                //     if (this.thresholds.length > 0) {
                                //         vRange = this.sensor_threshold_ranges['voc'];
                                //         if (vRange && vRange.length === 2)
                                //             outOfRange = v > vRange[1] || v < vRange[0];
                                //     } else {
                                //         outOfRange = false;
                                //     }
                                //     return <div key={key} className="col-md-2 p-2">{'VOC: ' + (v < 0 ? 0 : v) + ' ppb'} <Progress percent={100} size="small" strokeColor={!outOfRange ? "#52c41a" : "red"} showInfo={false} /></div>;

                                case 'co':
                                    // v = v * 0.001;
                                    if (thresholds.length > 0) {
                                        vRange = sensor_threshold_ranges['co'];
                                        if (vRange && vRange.length === 2)
                                            outOfRange = v > vRange[1] || v < vRange[0];
                                    } else {
                                        outOfRange = false;
                                    }
                                    return <div key={key} className="col-md-2 p-2">{'CO: ' + (v < 0 ? 0 : Math.round(v)) + ' ppm'} <Progress percent={100} size="small" strokeColor={!outOfRange ? "#52c41a" : "red"} showInfo={false} /></div>;


                                case 'co2':
                                    if (thresholds.length > 0) {
                                        vRange = sensor_threshold_ranges['co2'];
                                        if (vRange && vRange.length === 2)
                                            outOfRange = v > vRange[1] || v < vRange[0];
                                    } else {
                                        outOfRange = false;
                                    }
                                    return <div key={key} className="col-md-2 p-2">{'CO2: ' + (v < 0 ? 0 : v) + ' ppm'} <Progress percent={100} size="small" strokeColor={!outOfRange ? "#52c41a" : "red"} showInfo={false} /></div>;

                                case 'leak':
                                    return <div key={key} className="col-md-2 p-2">{v === 0 ? 'No Leak' : <><i className='fa fa-tint text-info'></i> Water Leak</>} <Progress percent={100} size="small" strokeColor={v === 0 ? "#52c41a" : "red"} showInfo={false} /></div>

                                case 'flow':
                                    return <div key={key} className="col-md-2 p-2">{v === 0 ? 'No Water Flow' : <><i className='fa fa-tint text-info'></i> Water Flow</>} <Progress percent={100} size="small" strokeColor={v === 0 ? "red" : "#52c41a"} showInfo={false} /></div>

                                default:
                                    return '';
                            }
                        })}
                </div>
            }
        },
        {
            title: 'Status',
            dataIndex: 'group_permission',
            key: 'group_permission',
            render: (text, record) => {
                let alerts = [];
                if (record.humidity_state_alert)
                    alerts.push('Humidity Alert');
                if (record.temperature_state_alert)
                    alerts.push('Temperature Alert');
                return alerts.join(' ');
            },
            width: '150px'
        },
        {
            title: 'Action',
            dataIndex: 'sensor_last_state',
            key: 'sensor_last_state',
            render: (text, record) => {
                const items = [
                    {
                        key: '1',
                        label: <span onClick={() => showRenameSensorModal(record)}> Rename Sensor </span>,
                    }];

                return <div style={{ textAlign: "center" }}><Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
                    <a className="ant-dropdown-link" href="./" onClick={e => e.preventDefault()}>
                        <i className="fa fa-ellipsis-v"></i>
                    </a>
                </Dropdown>
                </div>
            },
            width: '50px'
        }
    ];


    const showRenameSensorModal = (sensor) => {
        bootbox.dialog({
            html: true,
            message: `
            <div className="row">
                <label class="text-app"><b>Rename Sensor</b></label>
            </div>
            <div class="row rename-sensor pt-3">
                <div class="col-md-12"><label class="text-primary">Sensor Serial Nr:</label> <span class="d-inline">`+ sensor.sensor_serial_number + `</span></div>
                <div class="col-md-12"><label class="text-primary">Sensor Name:</label> <input class="form-control d-inline" type="text" name="sensor_name" value="`+ (sensor.sensor_name || '') + `" autoComplete="off" /></div>
            </div>`,
            buttons: [
                { className: 'btn btn-white btn-close-rename-sensor', label: 'No' },
                {
                    className: 'btn btn-primary btn-save-rename-sensor',
                    callback: () => {
                        $('.btn-save-rename-sensor').attr('disabled', 'disabled');
                        let sensor_name = $('.rename-sensor').find('.form-control').val();

                        var regPattern = /^[0-9a-zA-Z ]+$/;
                        if (!regPattern.test(sensor_name)) {
                            return Toastr.error('Only Alphabets, Numbers, Space allowed.');
                        }

                        if (sensor_name.trim().length === 0)
                            return Toastr.error("Sensor name should not be empty");
                        setLoading(true);
                        CommonUtils.ajax(
                            {
                                url: API.COMMON_TABLE_OPERATIONS.REMOTE_SENSOR.MODIFY,
                                type: 'POST',
                                contentType: "application/json; charset=utf-8",
                                dataType: "json",
                                data: JSON.stringify({
                                    form_input: {
                                        sensor_type: sensor.sensor_type,
                                        sensor_id: sensor.sensor_id,
                                        sensor_name: sensor_name
                                    },
                                    "user_login": user.user_login,
                                    "user_token": user.user_token,
                                    "user_type": "user"
                                })
                            }
                        ).then(
                            (res) => {
                                if (res.status && res.status.code === 200) {
                                    let sensor_s = [...sensors];
                                    for (let s of sensor_s)
                                        if (s.sensor_id === sensor.sensor_id && s.sensor_type === sensor.sensor_type)
                                            s.sensor_name = sensor_name;

                                    setSensors(sensor_s);
                                    setLoading(false);
                                    Toastr.success('Sensor name modified successfully');
                                    $('.btn-close-rename-sensor').trigger('click');
                                    $('.btn-save-rename-sensor').removeAttr('disabled', 'disabled');
                                }
                            },
                            (err) => {
                                Toastr.error('Error occurred ... Please try again !');
                                $('.btn-close-rename-sensor').trigger('click');
                                $('.btn-save-rename-sensor').removeAttr('disabled', 'disabled');
                            }
                        );
                        return false;
                    }, label: 'Yes'
                }
            ]
        });
    }

    // handleInputChange = (e) => {
    //     let name = e.target.name;
    //     let sensor_activity = { ...this.state.sensor_activity };
    //     console.log(e.target.type);
    //     switch (e.target.type) {
    //         case 'checkbox':
    //             break;

    //         case 'text':
    //             sensor_activity[name] = e.target.value;
    //             break;

    //         default:
    //             break;
    //     }
    //     this.setState({ sensor_activity: sensor_activity });
    // }


    let s = sensor_activity;
    return (
        <React.Fragment>
            <div className="card bg-shadow border border-0 mb-5">
                <div className='card-header bg-white'>
                    <div className='card-title pl-2'>
                        <div className="row">
                            {thresholds.length > 0 &&
                                <React.Fragment>
                                    <div className="col-6 text-capitalize text-bold text-app mb-2 d-inline">Sensor Group: {s.activity_name}</div>
                                    <div className="col-6 text-right">
                                        <a className="btn btn-primary btn-xs font-size-12 py-1 px-2" href={"/site-management?id=" + s.activity_id + "#sensor-notifications"}>Edit</a>
                                    </div>
                                </React.Fragment>
                            }

                            {thresholds && thresholds.length > 0 && <div className='col-md-12 font-size-12 pb-1'>{thresholds.filter(t => t.notify_me || t.default === true).length > 0 ? <b>Alerts if :</b> : "No alerts configured."}</div>}
                            {thresholds.filter(t => t.notify_me || t.default === true).map(t => {
                                switch (t.sensor_id) {
                                    case 'temperature':
                                        sensor_threshold_ranges[t.sensor_id] = [t.alert_down, t.alert_up];
                                        return t.notify_me && <div key={s.activity_id + '_' + t.sensor_id} className="col-12 text-secondary font-size-12">
                                            <i className="fa fa-check text-primary"></i>&nbsp;
                                            <span><b>Temperature:</b> Below {t.alert_down}F or Above {t.alert_up}F</span>
                                        </div>;

                                    case 'humidity':
                                        sensor_threshold_ranges[t.sensor_id] = [t.alert_down, t.alert_up];
                                        return t.notify_me && <div key={s.activity_id + '_' + t.sensor_id} className="col-12 text-secondary font-size-12">
                                            <i className="fa fa-check text-primary"></i>&nbsp;
                                            <span><b>Humidity:</b> Below {t.alert_down}% or Above {t.alert_up}%</span>
                                        </div>

                                    // case 'voc':
                                    //     this.sensor_threshold_ranges[t.sensor_id] = [t.alert_down, t.alert_up];
                                    //     return <div key={s.activity_id + '_' + t.sensor_id} className="col-12 text-secondary font-size-12">
                                    //         <i className="fa fa-check text-primary"></i>&nbsp;
                                    //         <span><b>VOC:</b> Above {t.alert_up} ppb</span>
                                    //     </div>

                                    case 'co2':
                                        sensor_threshold_ranges[t.sensor_id] = [t.alert_down, t.alert_up];
                                        return t.notify_me && <div key={s.activity_id + '_' + t.sensor_id} className="col-12 text-secondary font-size-12">
                                            <i className="fa fa-check text-primary"></i>&nbsp;
                                            <span><b>CO2:</b> Above {t.alert_up} ppm</span>
                                        </div>

                                    case 'co':
                                        sensor_threshold_ranges[t.sensor_id] = [t.alert_down, t.alert_up];
                                        return t.notify_me && <div key={s.activity_id + '_' + t.sensor_id} className="col-12 text-secondary font-size-12">
                                            <i className="fa fa-check text-primary"></i>&nbsp;
                                            <span><b>CO:</b> Above {t.alert_up} ppm</span>
                                        </div>

                                    case 'leak':
                                        sensor_threshold_ranges[t.sensor_id] = [t.alert_down, t.alert_up];
                                        return t.notify_me && <div key={s.activity_id + '_' + t.sensor_id} className="col-12 text-secondary font-size-12">
                                            <i className="fa fa-check text-primary"></i>&nbsp;
                                            <span><b>Water Leak</b> is detected. <i>(Sensor value: {t.alert_up})</i></span>
                                        </div>

                                    case 'flow':
                                        sensor_threshold_ranges[t.sensor_id] = [t.alert_down, t.alert_up];
                                        return t.notify_me && <div key={s.activity_id + '_' + t.sensor_id} className="col-12 text-secondary font-size-12">
                                            <i className="fa fa-check text-primary"></i>&nbsp;
                                            <span><b>Water flow</b><i>({t.alert_up ? "Yes" : "No"})</i></span>
                                        </div>

                                    default:
                                        return ""
                                }
                            })}
                            {thresholds.length === 0 && <div className="col-md-12">Below sensors are not part of sensor groups. <br />Visit <a href="/site-management#sensor-notifications">Sensor Notifications</a> page to add sensor groups with threshold information to trigger sensor notifications.</div>}
                        </div>
                    </div>
                </div>
                <div className="card-body font-size-11 antd-plain-table ml-2">
                    {loading ? <Loading></Loading> : <Table
                        pagination={false}
                        rowKey={'sensor_serial_number'}
                        columns={sensor_table_cols}
                        dataSource={thresholds.length === 0 ? [...sensors] : [...sensors.filter(s => s.hasOwnProperty('group_id') && s.group_id === sensor_activity.activity_id)]}
                        expandable={{
                            expandedRowRender: row => <div className="p-5 text-center"><SensorChart sensor_serial_number={row.sensor_serial_number} sensor_id={row.sensor_type + "_" + row.sensor_id}></SensorChart></div>,
                            rowExpandable: record => true
                        }}
                    />}
                </div>
            </div>

        </React.Fragment>
    );
}

export default SensorRecord;